import { render, staticRenderFns } from "./FullBoardDetails.vue?vue&type=template&id=6cc75269&scoped=true"
import script from "./FullBoardDetails.vue?vue&type=script&lang=js"
export * from "./FullBoardDetails.vue?vue&type=script&lang=js"
import style0 from "./FullBoardDetails.vue?vue&type=style&index=0&id=6cc75269&prod&lang=less&scoped=true"
import style1 from "./FullBoardDetails.vue?vue&type=style&index=1&id=6cc75269&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc75269",
  null
  
)

export default component.exports